import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientDetails } from '../../../models/client-details';
import { Address, EnumAddressType } from '../../../models/address';
import { Phone } from '../../../models/phone';
import { ConfigWebsite } from '../../../models/config-website';
import { NewsletterResponse } from '../../../models/newsletter-response';
import { ClientService } from '../../client.service';
import { WebsiteSaleService } from '../../../shared/services/website-sale.service';
import { MessageAction, MessageObserverService } from '../../../../../projects/shared-lib/src/lib/services/message-observer.service';
import { Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { Country, AddressComponent } from '../../../address/address/address.component';
import { lastValueFrom } from 'rxjs';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { PhoneFormComponent } from '../../../shared/component/phone-form/phone-form.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'tw-client-invoice-checkout',
    templateUrl: './client-invoice-checkout.component.html',
    styleUrls: ['./client-invoice-checkout.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, AddressComponent, PhoneFormComponent, MatButton, TranslatePipe]
})
export class ClientInvoiceCheckoutComponent implements OnInit {
    profileForm: UntypedFormGroup;
    @Output() clientChange = new EventEmitter<ClientDetails>();
    @Output() openShipPanel = new EventEmitter<boolean>();
    @Output() countryOrProvinceChange = new EventEmitter<Country>();
    @Input() client: ClientDetails = <ClientDetails>{};
    @Input() clientClone: ClientDetails;
    @Input() isOnlyMember: boolean;
    address: Address = <Address>{};
    phone: Phone = <Phone>{};
    load = true;
    isProfileGuest = false;
    configWebsite: ConfigWebsite;
    newsletters: NewsletterResponse;
    isCheckoutPage = false;
    constructor(public clientService: ClientService,
                private fb: UntypedFormBuilder,
                private websiteSaleService: WebsiteSaleService,
                private messageObserverService: MessageObserverService,
                private router: Router,
                public translate: TranslateService,
                private analyticsService: AnalyticsService
    ) {
        this.configWebsite = this.websiteSaleService.getLocalConfig();


    }

    static convertToPhone(val): Phone {
        const phone = <Phone>{};
        if (val) {
            phone.number = val.number;

        }
        return phone;
    }

    static convertToAddress(val, type ?: EnumAddressType): Address {
        const address = <Address>{};
        if (val) {
            address.addressLine1 = val.addressLine1;
            address.addressLine2 = val.addressLine2;
            address.appartment = val.appartment;
            address.city = val.city;
            address.zipCode = val.zipCode;
            address.country = val._country || val.country;
            address.company = val.company;
            if (!type) {
                address.type = EnumAddressType.BILLING;
            } else {
                address.type = type;
            }

            if (val._country === 'CA' || val.country === 'CA' || val.country === 'CANADA') {
                address.province = val.statesCAD;
            } else if (val._country === 'US' || val.country === 'US') {
                address.province = val.statesUS;
            } else {
                address.province = val.statesWorld;
            }
        }
        return address;
    }

    ngOnInit() {

        ///this.client = this.clientService.getClientLocal();
        // this.address = this.clientService.getClientLocal().addresses[0;
        // this.phone = this.clientService.getClientLocal().phones[0];
        this.isCheckoutPage = !(this.router.url.search('mode') === -1) || !(this.router.url.search('checkout') === -1);


        this.clientClone = JSON.parse(JSON.stringify(this.client));
        // console.log(this.client);
        if (this.clientClone && this.clientClone.addresses && this.clientClone.addresses[0]) {
            this.address = this.clientClone.addresses[0];
        }
        if (this.clientClone && this.clientClone.phones && this.clientClone.phones[0]) {
            this.phone = this.clientClone.phones[0];
        }
        this.analyticsService.trackProfileView();
        this.profileForm = this.fb.group({
            address: this.fb.group({}),
            phone: this.fb.group({}),
            client: this.fb.group({
                firstname: this.fb.control((this.clientClone && this.clientClone.firstname) ? this.clientClone.firstname : ''),
                lastname: this.fb.control((this.clientClone && this.clientClone.lastname) ? this.clientClone.lastname : '')
            })
        });

        this.profileForm.statusChanges.subscribe(status => {
            //console.log(this.profileForm.value);
            this.convertToClientRequest(this.profileForm.value);
            //console.log(this.profileForm.status);
            //console.log(status)
            const temp = <ClientDetails>{ ...this.client, status: status };
            //  console.log(temp)
            /*** gerer le mode guest   ****/

            // this.clientChange.emit(temp);
        });

    }


    get addressGroup() {
        return this.profileForm.get('address');
    }

    get clientGroup() {
        return this.profileForm.get('client');
    }

    get phoneGroup() {
        return this.profileForm.get('phone');
    }

    convertToClientRequest(val) {
        const clone = JSON.parse(JSON.stringify(val));
        this.client = JSON.parse(JSON.stringify(val.client));
        this.client.addresses = [];
        this.client.addresses.push(ClientInvoiceCheckoutComponent.convertToAddress(clone.address));
        this.client.phones = [];
        this.client.phones.push(ClientInvoiceCheckoutComponent.convertToPhone(clone.phone));
        const cl = this.clientService.getClientLocal();
        if (cl && cl.id) {
            this.client.id = cl.id;
        }

        if (!this.isProfileGuest) {
            this.client.username = this.client.email;
        }
        this.client.accountId = this.configWebsite.accountId;
        //   console.log( this.checkoutCartRequest);
    }

    async updateClient() {
        this.load = false;
        // console.log(this.profileForm.value);
        //console.log(this.client);
        if (!this.profileForm.valid) {
            this.profileForm.markAllAsTouched();
            this.messageObserverService.addMessage(<MessageAction>{ dialog: true, message: 'error.fillRequired', translate: true });
            this.load = true;
            return;
        }
        if (this.configWebsite.clientAccount === 'NO') {
            const temp = <ClientDetails>{ ...this.client, status: this.profileForm.status };
            this.clientChange.emit(temp);
            const country = <Country>{};
            country.country = this.client.addresses[0].country;
            country.province = this.client.addresses[0].province;
            if (country.country === 'CA') {
                const a = this.validCodePostal(this.client.addresses[0].zipCode);
                if (!a) {
                    this.messageObserverService.addMessage(<MessageAction>{ dialog: true, message: 'title.invalidePostal', translate: true });
                    this.load = true;
                    return;
                }
            }
            this.countryChange(country);
            this.openShipPanel.emit(true);
            return;
        }

        let clientLocal = <ClientDetails>JSON.parse(JSON.stringify(this.clientService.getClientLocal()));
        if (clientLocal) {
            try {
                clientLocal = await lastValueFrom(this.clientService.getClientSelf());
                clientLocal.addresses = this.client.addresses;
                clientLocal.phones = this.client.phones;
                //console.log(clientLocal);
                await lastValueFrom(this.clientService.updateClient(clientLocal));
                //console.log('updated sucess======================================');

                const temp = <ClientDetails>{ ...this.client, status: 'VALID' };
                this.clientChange.emit(temp);
                const country = <Country>{};
                country.country = clientLocal.addresses[0].country;
                country.province = clientLocal.addresses[0].province;

                this.countryChange(country);
                this.openShipPanel.emit(true);
                //this.hasRightOpenShipping = true;
                //this.invoiceReadOnly = true;
            } catch (error1) {
                console.log(error1);
                this.load = true;
                if (error1 && error1.error && error1.error.error && error1.error.error.message) {
                    this.messageObserverService.addMessage(<MessageAction>{ dialog: true, message: error1.error.error.message });
                } else {
                    this.messageObserverService.addMessage(<MessageAction>{ dialog: true, translate: true, message: 'formMsg.failureProcessing' });
                }
            }

        }
        return;
    }

    validCodePostal(postalCode, isUsa = false) {
        if (!postalCode) {
            return false;
        }

        postalCode = postalCode.toString().trim();

        const us = new RegExp('^\\d{5}(-{0,1}\\d{4})?$');
        const ca = new RegExp(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i);

        if (isUsa && us.test(postalCode.toString())) {
            return true;
        }

        if (ca.test(postalCode.toString().replace(/\W+/g, ''))) {
            return true;
        }
        return false;

    }

    countryChange($event: Country) {
        this.countryOrProvinceChange.emit($event);
    }
}
